<template>
  <div class="group__topic">
    <div class="topic">
      <aside class="topic__aside">
        <div class="topic__card">
          <transition-group name="expand">
            <div class="topic__details" :key="topicTitle">
              <div class="topic__title">{{ topicTitle }}</div>
              <div
                v-if="isUser && expand"
                class="topic__notes-wrapper"
                key="topicContent"
              >
                <Notes :content="topicContent" />
              </div>
            </div>
            <p class="topic__detail" v-if="expand" key="topicDetail">
              <span class="topic__lead">Activities:</span>
              <span class="topic__data">{{ topicContent.length }}</span>
            </p>
            <TopicProgress
              key="topicProgress"
              v-if="isUser && topicProgress && expand"
              :topicProgressCompleted="topicProgress.completed"
              :topicContentLength="topicContent.length"
            />
          </transition-group>
        </div>
        <div @click="handleToggleClick" class="topic__toggle">
          {{ toggleText }}
        </div>
      </aside>
    </div>
    <transition name="component-fade" mode="out-in">
      <Levels
        :leaves="topicContent"
        :progress="progress"
        class="topic__level-wrapper"
        v-if="expand"
        key="Levels"
      />
      <TopicProgress
        class="topic-progress__centered"
        v-if="isUser && topicProgress && !expand"
        :topicProgressCompleted="topicProgress.completed"
        :topicContentLength="topicContent.length"
        key="progress"
      />
    </transition>
  </div>
</template>

<script>
import Notes from '@/components/course/content/Notes.vue'
import Levels from '@/components/course/content/Levels.vue'
import TopicProgress from '@/components/course/content/TopicProgress.vue'

export default {
  name: 'Topic',
  components: {
    TopicProgress,
    Notes,
    Levels,
  },
  data() {
    return {
      expand: this.topicProgress.completed < this.topicContent.length,
    }
  },
  props: {
    isUser: {
      required: false,
      type: Boolean,
    },
    topicTitle: {
      required: true,
      type: String,
    },
    topicProgress: {
      required: false,
      type: Object,
    },
    topicContent: {
      type: Array,
      required: true,
    },
    progress: {
      type: [Object, String],
      required: false,
    },
  },
  computed: {
    toggleText() {
      return this.expand ? 'Hide details' : 'Show details'
    },
  },
  methods: {
    handleToggleClick() {
      this.expand = !this.expand
    },
  },
}
</script>

<style lang="scss" scoped>
.group__topic {
  display: flex;
  width: 100%;

  .component-fade-enter-active {
    transition: opacity 0.2s ease;
    overflow: hidden;
  }

  .component-fade-leave-active {
    transition: opacity 0.4s ease;
    overflow: hidden;
  }

  .component-fade-enter,
  .component-fade-leave-to {
    opacity: 0;
  }
}
.topic {
  width: 100%;
  background: linear-gradient(
    104.99deg,
    rgba(62, 63, 73, 0.7) -13.91%,
    rgba(62, 63, 73, 0) 100.48%
  );
  border-radius: 5px;
  padding: 30px 23px 30px 30px;
  color: var(--white);
  @include tablet {
    width: 25%;
    margin: 0;
    padding: 30px;
    min-height: 144px;
    max-width: 238px;
  }
  &__title {
    font-size: 20px;
    font-weight: 700;
    margin: 0 0 22px 0;
    max-width: 90%;
    font-family: var(--font-book);
  }

  &__detail {
    margin: 0;
    padding: 0;
  }
  &__lead {
    margin: 0 5px 0 0;
    font-size: 16px;
  }
  &__data {
    font-size: 16px;
  }
  &__notes-wrapper {
    width: 100%;
    margin: -10px 0 0 0;
  }
  &__level-wrapper {
    width: 100%;
    padding: 20px 20px 10px 20px;
  }
  &__toggle {
    text-decoration: underline;
    margin-top: auto;
    color: var(--light-blue-gray);
    &:hover {
      cursor: pointer;
      color: var(--white);
    }
  }
  &__aside {
    height: 100%;
    display: flex;
    flex-direction: column;

    .expand-enter-active {
      transition: opacity 0.4s ease;
      overflow: hidden;
    }

    .expand-leave-active {
      transition: opacity 0.3s ease;
      overflow: hidden;
    }

    .expand-enter {
      opacity: 0;
    }

    .expand-leave-to {
      opacity: 0;
    }
  }
}
</style>
